import s from "./styles.module.sass";

const WhoAreWe = () => {
	return (
		<section className="marginedSection">
			<h3>Кто мы?</h3>
			<section className={s.whoAreWe}>
				<div className={s.info}>
					<p className={s.aboutSelfSchool}>
						Selfschool — проект для людей, которые любят учиться и обмениваться знаниями
					</p>
					<p>
						<b>Мы школа.</b> Мы считаем, что обучение — непрерывный процесс, который сопровождает человека на
						протяжении жизни. Верим: с помощью Selfschool легко понять, как получать удовольствие от
						постоянного развития, прослушивания лекций и выполнения заданий.
					</p>
					<p>
						<b>Мы маркетплейс.</b> Мы предлагаем взять на себя роль ученика или учителя: на Selfschool вы
						можете создать обучающий продукт или изучать программы других людей. Пробуйте себя в разном:
						станьте слушателем курса в один день и автором, который делится своей экспертизой, — в другой.
						Быть открытым новому — часть нашей философии.
					</p>
					<p>
						<b>Мы сообщество.</b> Мы объединяем людей, которые стремятся к изучению нового и
						самосовершенствованию. Общение экспертов, наставников, учеников, лекторов и слушателей помогает
						каждому найти ответы на самые сложные вопросы.
					</p>
				</div>
				<div className={s.image} />
			</section>
		</section>
	);
};

export default WhoAreWe;
